"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CheckboxPure = void 0;
var react_1 = __importDefault(require("react"));
exports.CheckboxPure = function Checkbox(props) {
    var dataCy = props.dataCy, error = props.error, title = props.title, rest = __rest(props, ["dataCy", "error", "title"]);
    return (react_1.default.createElement("label", { className: "checkbox-container clean", "data-cy": dataCy },
        react_1.default.createElement("input", __assign({ type: "checkbox" }, rest)),
        react_1.default.createElement("span", { className: "checkbox " + (error && 'has-error') + " " + (rest.disabled && 'disabled'), "data-testid": "input-checkbox-error" },
            react_1.default.createElement("i", { className: "fas fa-check" })),
        react_1.default.createElement("span", { className: "title " + (rest.disabled && 'disabled') }, title)));
};
//# sourceMappingURL=CheckboxPure.js.map